import React from "react";
import useStyles from "../styles";
import Table from "@material-ui/core/Table";
import {TableCell, TableHead, TableRow} from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import moment from "moment";

const SelectedDay = ({selectedDay, selectedTime, selectedSchedule, scheduleForSelectedDay, handleClickOnTime}) => {
    const classes = useStyles();

    return (selectedDay && <div className={classes.selectDay}>
        <div className={classes.monthHeading}>
            <h1 className={classes.monthHeadingText}>
                ВИБРАНИЙ ЧАС
            </h1>
        </div>
        <Table className={classes.tableDay}>
            <TableHead>
                <TableRow>
                    <TableCell colSpan={3} className={classes.tableCellBorderNone}>Оберіть зручний для вас час:</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {selectedDay.receptionHours.map((item, idx) => {
                    return (<TableRow key={'row' + idx}>
                        {item.map((time, index) => {
                            const isSelectedTime = selectedTime === time;
                            const isReservedTime = selectedSchedule && selectedSchedule.find(reserved => {
                                if (moment(reserved.dt).dayOfYear() === moment(selectedDay.dt_start).dayOfYear()) {
                                    if (moment(reserved.dt).hour() === +time.split(':')[0]
                                        && (moment(reserved.dt).minute() === +time.split(':')[1]
                                            || (moment(reserved.dt).minute() > +time.split(':')[1]
                                                && moment(reserved.dt).minute() < +time.split(':')[1] + 20))
                                    ) {
                                        return true;
                                    }
                                }
                                return false;
                            })

                            const isHourGreaterThenNow = selectedDay
                                && (moment(selectedDay.dt_start).dayOfYear() === moment().dayOfYear())
                                && (+time.split(':')[0] < moment().hour() || (+time.split(':')[0] === moment().hour() && moment().minute() >= +time.split(':')[1]))

                            const isNotWorkingTime = scheduleForSelectedDay
                                && scheduleForSelectedDay.length > 1
                                && scheduleForSelectedDay.reduce((acu, cur, idx, src) => {
                                    if (idx === 0) {
                                        return acu;
                                    }
                                    if (moment(src[idx - 1].dt_end).hour() <= +time.split(':')[0] && moment(cur.dt_start).hour() > +time.split(':')[0]) {
                                        return true;
                                    } else {
                                        return acu;
                                    }
                                }, false);

                            return (<TableCell
                                key={time + index}
                                className={isSelectedTime
                                    ? classes.hourCellActive
                                    : isReservedTime || isNotWorkingTime
                                        ? classes.hourCellNotActive
                                        : isHourGreaterThenNow ? classes.hourCellNotActive : classes.hourCell
                                }
                                onClick={(event) => !isSelectedTime && !isReservedTime && !isHourGreaterThenNow && handleClickOnTime(event, time)}
                            >
                                {time}
                            </TableCell>)
                        })}
                    </TableRow>)
                })}
            </TableBody>
        </Table>
    </div>);
}

export default SelectedDay;
